var _path, _path2, _path3, _path4, _path5, _path6, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnketa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 58,
    viewBox: "0 0 60 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.1193 7.19444H14.1944C12.5516 7.19444 10.976 7.84707 9.81431 9.00875C8.65263 10.1704 8 11.746 8 13.3889V50.5556C8 52.1984 8.65263 53.774 9.81431 54.9357C10.976 56.0974 12.5516 56.75 14.1944 56.75H45.1667C46.8095 56.75 48.3851 56.0974 49.5468 54.9357C50.7085 53.774 51.3611 52.1984 51.3611 50.5556V22.2716",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6953 45.9673L35.3661 49.6381L42.7077 42.2965",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6953 19.0001H42.6953",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6953 25.0001H42.6953",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6953 31.0001H42.6953",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6953 37.0001H27.6953",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 51.5,
    cy: 9.5,
    r: 8.5,
    fill: "#FF004D",
    fillOpacity: 0.3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 51.5,
    cy: 9.5,
    r: 4.5,
    fill: "#FF004D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnketa);
export default __webpack_public_path__ + "static/media/anketa.c54708daf30a8b23d727cb7fc4a29fc9.svg";
export { ForwardRef as ReactComponent };